

<template>
  <div class="PortfolioList">
    <div class="PortfolioItemWarp" v-for="v in pList" :key="v.id">
      <div class="PortfolioItem" @click="openLink(v)">
        <img :src="v.avatar" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    pList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return {
      openLink(v){
        this.$emit('openInfo',v)
        return false;
        if(v.c_url){
          try {
            window.open(v.c_url)
          }catch (e){
            window.location.href = v.c_url
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.PortfolioList{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-top: -1rem;
  .PortfolioItemWarp{
    width: 50%;
    padding-left: 1rem;
    padding-top: 1rem;
    box-sizing: border-box;
    .PortfolioItem{
      cursor: pointer;
      img{
        transition: .5s;
        width: 100%;
      }
    }
  }
}
</style>
